export default __webpack_public_path__ + "static/media/ship-img.f9823352.svg";